import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, Button, Box } from "@mui/material";
import { ExitToApp } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

interface CustomAppBarProps {
  title?: string;
}

const CustomAppBar: React.FC<CustomAppBarProps> = ({ title }) => {
  const navigate = useNavigate();
  const [isFirstImage, setIsFirstImage] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsFirstImage((prev) => !prev);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <AppBar
      position="fixed"
      sx={{
        bgcolor: "white",
        height: "10vh",
        boxShadow: "none",
        color: "black",
      }}
    >
      <Toolbar sx={{ px: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
          {/* Imagen con transición automática */}
          <Box
            sx={{
              position: "relative",
              height: { xs: "45px", sm: "60px", md: "80px" },
              width: "auto",
              cursor: "pointer",
            }}
          >
            {/* Imagen 1 */}
            <Box
              component="img"
              src="/assets/images/logo-alien1-v3.png"
              alt="Logo 1"
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                height: "100%",
                width: "auto",
                opacity: isFirstImage ? 1 : 0,
                transition: "opacity 0.5s ease-in-out",
                '&:hover': {
                  filter: 'brightness(1.1) drop-shadow(0px 0px 1px cyan)',
                }
              }}
            />
            {/* Imagen 2 */}
            <Box
              component="img"
              src="/assets/images/logo-alien2-v3.png"
              alt="Logo 2"
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                height: "100%",
                width: "auto",
                opacity: isFirstImage ? 0 : 1,
                transition: "opacity 0.5s ease-in-out",
                '&:hover': {
                  filter: 'brightness(1.1) drop-shadow(0px 0px 1px cyan)',
                }
              }}
            />
          </Box>

          {title && (
            <Box component="span" sx={{ ml: 2, fontWeight: "bold" }}>
              {title}
            </Box>
          )}
        </Box>

        <Button
          variant="outlined"
          color="inherit"
          startIcon={<ExitToApp />}
          onClick={() => navigate(-1)}
        >
          Salir
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default CustomAppBar;
